/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './dosage-guideline.reducer';

export const DosageGuidelineDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const dosageGuidelineEntity = useAppSelector(state => state.dosageGuideline.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="dosageGuidelineDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.dosageGuideline.detail.title">DosageGuideline</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.id">Id</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.name">Name</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.description">Description</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.description}</dd>
          <dt>
            <span id="dosageValue">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.dosageValue">Dosage Value</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.dosageValue}</dd>
          <dt>
            <span id="dosageUnit">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.dosageUnit">Dosage Unit</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.dosageUnit}</dd>
          <dt>
            <span id="recommendedDosage">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.recommendedDosage">Recommended Dosage</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.recommendedDosage}</dd>
          <dt>
            <span id="administrationRoute">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.administrationRoute">Administration Route</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.administrationRoute}</dd>
          <dt>
            <span id="specialInstructions">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.specialInstructions">Special Instructions</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.specialInstructions}</dd>
          <dt>
            <span id="asNeeded">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.asNeeded">As Needed</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.asNeeded ? 'true' : 'false'}</dd>
          <dt>
            <span id="asNeededCondition">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.asNeededCondition">As Needed Condition</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.asNeededCondition}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.active">Active</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{dosageGuidelineEntity.timestampEntry}</dd>
        </dl>
        <Button tag={Link} to="/dosage-guideline" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/dosage-guideline/${dosageGuidelineEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DosageGuidelineDetail;
